import Spine from '@finviz/spine'

import { TodoObjectHashAnyType } from '../../types/shared'

type TodoContextConfig = TodoObjectHashAnyType

class ContextMenu extends Spine.Model {
  static initClass() {
    this.configure('ContextMenu', 'shown', 'config', 'top', 'left')
  }

  declare shown: boolean
  declare config: TodoContextConfig
  declare top: number
  declare left: number
}

ContextMenu.initClass()

const contextMenu = ContextMenu.create() as ContextMenu
contextMenu.save()

export default contextMenu
